import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  heading: {
    margin: 0,
    textAlign: 'center'
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  continueButton: {
    height: theme.spacing(6)
  },
  errorParagraph: {
    color: theme.palette.error.main,
    textAlign: 'center'
  },
  termsParagraph: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '26px',
    textAlign: 'center'
  },
  link: {
    fontWeight: 600,
    textDecoration: 'none'
  }
}));
